"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cmpUint8Array = void 0;
const cmpUint8Array = (a, b) => {
    const length = a.length;
    if (length !== b.length)
        return false;
    for (let i = 0; i < length; i++)
        if (a[i] !== b[i])
            return false;
    return true;
};
exports.cmpUint8Array = cmpUint8Array;
